import { render, staticRenderFns } from "./IlluBulle.vue?vue&type=template&id=4c3704e4&"
import script from "./IlluBulle.vue?vue&type=script&lang=js&"
export * from "./IlluBulle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports